export enum AvailableLocales {
  FR_FR = 'fr-FR',
  EN_US = 'en-US',
  ES_ES = 'es-ES',
  IT_IT = 'it-IT',
  PL_PL = 'pl-PL',
  PT_BR = 'pt-BR',
  HT_HT = 'ht-HT',
  FR_CA = 'fr-CA',
  DE_DE = 'de-DE',
  JA_JP = 'ja-JP',
  HI_IN = 'hi-IN',
  ZH_CN = 'zh-CN',
  ZH_TW = 'zh-TW',
  KO_KR = 'ko-KR',
}

/**
 * SupportedLocale — type-safe union of locale strings accepted by the UI.
 *
 * This union includes both the canonical "dash" forms used in the codebase
 * (e.g. `en-US`) and the underscore variants that are stored in our database
 * (e.g. `en_US`). Accepting both formats lets callers pass values directly from
 * the DB without manual conversion.
 *
 * Notes:
 *  - The canonical runtime enum for locales is `AvailableLocales` (dash forms).
 *  - Use `normalizeLocale()` in `frontends/wx-ui/src/utils/translations/index.ts`
 *    to convert a `SupportedLocale` into an `AvailableLocales` value for
 *    lookups and runtime behavior.
 *
 * Examples:
 *  - 'en-US'  // dash format, matches AvailableLocales.EN_US
 *  - 'en_US'  // underscore format as stored in DB — normalized to 'en-US'
 *
 * Why both forms?
 *  - Back-end storage historically uses underscores. Accepting both makes the
 *    prop ergonomic for callers while preserving strong typing in TypeScript.
 */
export type SupportedLocale =
  | 'fr-FR'
  | 'fr_FR'
  | 'en-US'
  | 'en_US'
  | 'es-ES'
  | 'es_ES'
  | 'it-IT'
  | 'it_IT'
  | 'pl-PL'
  | 'pl_PL'
  | 'pt-BR'
  | 'pt_BR'
  | 'ht-HT'
  | 'ht_HT'
  | 'fr-CA'
  | 'fr_CA'
  | 'de-DE'
  | 'de_DE'
  | 'ja-JP'
  | 'ja_JP'
  | 'hi-IN'
  | 'hi_IN'
  | 'zh-CN'
  | 'zh_CN'
  | 'zh-TW'
  | 'zh_TW'
  | 'ko-KR'
  | 'ko_KR';

export const LOCALE_EN_US = AvailableLocales.EN_US;
